/* eslint-disable import/prefer-default-export */
import { SET_QUESTION_FEEDBACK } from './actionTypes';

export const setQuestionFeedback = (payload: any) => ({
  type: SET_QUESTION_FEEDBACK,
  payload,
});
